import Vue from 'vue';
import store from './../../store';

// When the request succeeds
const success = (data, context) => {
    context.messages = data;
    context.loading = false;
};

// When the request fails
const failed = (error, context) => {
    context.loading = false;
    context.showToasterError(error);
};

export default (context) => {
  var param = '';
  if(context.selectedRental != 'all') {
    param = '?id=' + context.selectedRental
  }
  return Vue.$http.get(process.env.API_LOCATION + '/getMessages' + param, {
      headers: {
        'x-access-token': store.state.auth.token
      }
  }).then((response) => {
      if (response.status === 200) {
        success(response.data, context);
      } else {
        failed(error, context);
      }
    })
    .catch((error) => {
      failed(error, context);
    });
};



// WEBPACK FOOTER //
// ./src/app/services/message/get.js